import { odinClient } from "@/config/client"

interface NextQuestion {
  index: number
  question: string
  options: string[]
}

export interface NextQuestionChellange {
  index: number
  question: string
  options: string[]
}

export interface ChalangeActivity {
  id: string
  next: NextQuestion
  total: number
  current: number
  more: boolean
}

export interface CreateStudySessionResponse {
  description: ChalangeActivity
}

export interface Params {
  id: string
  body: { userActivityId: string }
}

export function create({ id, body }: Params) {
  return odinClient.post<CreateStudySessionResponse, Params["body"]>(
    `/v1/activities/${id}/challenges/study-session`,
    body,
  )
}
